export default function(value, range, left, right) {
  var r0 = range[0], r1 = range[range.length-1], t;
  if (r0 > r1) {
    t = r0;
    r0 = r1;
    r1 = t;
  }
  left = left === undefined || left;
  right = right === undefined || right;

  return (left ? r0 <= value : r0 < value) &&
    (right ? value <= r1 : value < r1);
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-parser/src/parsers/expression/inrange.js
// module id = 826
// module chunks = 0